/**
 * 將 App 語系 code 對應為 Google Identity Services 的 locale（BCP-47）
 */
export function mapGoogleLocale(appLocale = 'en_US') {
  const code = String(appLocale || '').trim();
  const map = {
    zh_TW: 'zh-TW',
    zh_HK: 'zh-TW',
    zh_CN: 'zh-CN',
    en_US: 'en',
    es_ES: 'es',
    fr_FR: 'fr',
    ru_RU: 'ru',
    ja_JP: 'ja',
    ko_KR: 'ko',
    de_DE: 'de',
    it_IT: 'it',
    pt_BR: 'pt-BR',
  };
  if (map[code]) {
    return map[code];
  }
  const prefix = code.split('_')[0];
  const prefixMap = {
    zh: 'zh-CN',
    en: 'en',
    es: 'es',
    fr: 'fr',
    ru: 'ru',
    ja: 'ja',
    ko: 'ko',
    de: 'de',
    it: 'it',
    pt: 'pt',
  };
  return prefixMap[prefix] || 'en';
}
